
import { Component, Prop, Vue } from 'vue-property-decorator';

// Services
import UserService from '@/utils/UserService';

// Components
import VUserAvatar from '@/components/VUserAvatar.vue';

// Interfaces
import { DesignHistory } from '@/ship/Models/Design';

@Component({
    components: {
        VUserAvatar,
    },
})
export default class VDesignChangelogItem extends Vue {
    @Prop({ type: Object, required: true })
    public history!: DesignHistory;

    get author() {
        return this.history.author?.data;
    }

    get authorName() {
        return UserService.getShortName(this.author);
    }

    get message() {
        return this.history.message;
    }

    get subMessage() {
        return this.history.submessage;
    }
}
